<template>
  <div class="contact-modal" :class="{ 'is-success': submitted }">
    <div class="modal-header">
      <span>{{ submitted ? '提交成功' : '上传会费缴纳凭证' }}</span>
      <i class="close" @click="cancel"></i>
    </div>

    <template v-if="submitted">
      <div class="modal-content success-content">
        <div class="success-icon">
          <svg focusable="false" width="1em" height="1em" fill="currentColor" viewBox="64 64 896 896" aria-hidden="true">
            <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"></path>
          </svg>
        </div>
        <div class="success-title">{{ successMessage }}</div>
      </div>
      <div class="modal-footer">
        <button class="confirm" type="button" @click="cancel">关闭</button>
      </div>
    </template>

    <template v-else>
      <div class="modal-content">
        <!-- 个人会员：左右两列紧凑布局 -->
        <template v-if="isPersonal">
          <div class="info-grid">
            <div class="info-col">
              <div class="fee-standard">
                <span class="fee-standard-label">个人会费标准</span>
                <span class="fee-standard-value"><em>{{ feeAmount }}</em>元/届（五年）</span>
              </div>
              <div class="account-card">
                <div class="account-card-title">收款账户信息</div>
                <div class="account-row">
                  <span class="label">账户名称</span>
                  <span class="value">浙江省风景园林学会</span>
                </div>
                <div class="account-row">
                  <span class="label">开户银行</span>
                  <span class="value">广发银行股份有限公司杭州西湖支行</span>
                </div>
                <div class="account-row">
                  <span class="label">账　　号</span>
                  <span class="value value-account">9550880234311200104</span>
                </div>
                <div class="account-row">
                  <span class="label">开户行号</span>
                  <span class="value">306331003101</span>
                </div>
              </div>
            </div>
            <div class="info-col">
              <div class="pay-notice">
                <p>缴费方式为银行转账或邮局汇寄。银行转账时，务必正确填写省学会的开户银行和账号，并注明“缴费姓名+会费”字样说明。</p>
                <p class="contact">
                  联系人：丁一心<br />
                  联系电话：0571-87999751、88832250
                </p>
              </div>
              <div class="upload-section">
                <div class="upload-section-title">上传打款凭证 <em>至少 1 张图片</em></div>
                <div class="upload-zone" :class="{ 'has-files': form.attachFileList.value.length, loading: loading }">
                  <div class="upload-add">
                    <i class="upload-add-icon"></i>
                    <span class="upload-add-text">{{ loading ? '上传中…' : '点击上传附件' }}</span>
                    <input v-if="!loading" type="file" accept="image/*" @change="onFileChange">
                  </div>
                  <div class="error-tip" v-if="form.attachFileList.error">{{ form.attachFileList.error }}</div>
                  <div class="upload-file-wrap" v-if="form.attachFileList.value.length">
                    <div
                      class="upload-file"
                      v-for="(item, index) in form.attachFileList.value"
                      :key="index"
                    >
                      <img :src="item.url" alt="">
                      <span :title="item.name">{{ item.name }}</span>
                      <i class="upload-file-delete" @click="deleteFile(index)"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- 团体会员 -->
        <template v-else>
          <div class="info-grid">
            <div class="info-col">
              <div class="fee-standard">
                <span class="fee-standard-label">当前待缴纳会费</span>
                <span class="fee-standard-value"><em>{{ feeAmount }}</em>元</span>
              </div>
              <div class="account-card">
                <div class="account-card-title">收款账户信息</div>
                <div class="account-row">
                  <span class="label">账户名称</span>
                  <span class="value">浙江省风景园林学会</span>
                </div>
                <div class="account-row">
                  <span class="label">开户银行</span>
                  <span class="value">广发银行股份有限公司杭州西湖支行</span>
                </div>
                <div class="account-row">
                  <span class="label">账　　号</span>
                  <span class="value value-account">9550880234311200104</span>
                </div>
                <div class="account-row">
                  <span class="label">开户行号</span>
                  <span class="value">306331003101</span>
                </div>
              </div>
            </div>
            <div class="info-col">
              <div class="pay-notice">
                <p>缴费方式为银行转账或邮局汇寄。银行转账时，务必正确填写省学会的开户银行和账号，并注明“单位名称+会费”字样说明。</p>
                <p class="contact">
                  联系人：丁一心<br />
                  联系电话：0571-87999751、88832250
                </p>
              </div>
              <div class="upload-section">
                <div class="upload-section-title">上传打款凭证 <em>至少 1 张图片</em></div>
                <div class="upload-zone" :class="{ 'has-files': form.attachFileList.value.length, loading: loading }">
                  <div class="upload-add">
                    <i class="upload-add-icon"></i>
                    <span class="upload-add-text">{{ loading ? '上传中…' : '点击上传附件' }}</span>
                    <input v-if="!loading" type="file" accept="image/*" @change="onFileChange">
                  </div>
                  <div class="error-tip" v-if="form.attachFileList.error">{{ form.attachFileList.error }}</div>
                  <div class="upload-file-wrap" v-if="form.attachFileList.value.length">
                    <div
                      class="upload-file"
                      v-for="(item, index) in form.attachFileList.value"
                      :key="index"
                    >
                      <img :src="item.url" alt="">
                      <span :title="item.name">{{ item.name }}</span>
                      <i class="upload-file-delete" @click="deleteFile(index)"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <div class="footer-tip">缴款凭证将用于核实会费缴纳情况，我们将尽快与您联系并审核相关材料，请耐心等待。</div>
      </div>
      <div class="modal-footer">
        <button class="cancel" type="button" @click="cancel">取消</button>
        <button class="confirm" type="button" :disabled="submitting" @click="confirm">
          {{ submitting ? '提交中…' : '提交' }}
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import { uuid } from '@/service/util';
import upload from '@/service/upload';
import { payMemFee } from '../service/api';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      submitting: false,
      submitted: false,
      form: {
        attachFileList: {
          value: [],
          error: false,
          validate: (v) => {
            if (!v.length) {
              this.form.attachFileList.error = '请上传图片至少1张';
              return false;
            }
            this.form.attachFileList.error = null;
            return true;
          },
        },
      },
    };
  },
  computed: {
    ...mapState(['user']),
    isPersonal() {
      return this.user && this.user.memType === 'personal';
    },
    feeAmount() {
      if (this.isPersonal) {
        return 250;
      }
      const key = this.user && this.user.memOrgVo && this.user.memOrgVo.orgTypeDicKey;
      if (key === '1503') return 3000;
      if (key === '1502') return 6000;
      if (key === '1501') return 9000;
      return '-';
    },
    successMessage() {
      if (this.isPersonal) {
        return '您的缴费信息已成功提交，我们将于5天内尽快审批，审批通过后下载个人会员证书。';
      }
      return '您的缴费信息已成功提交，我们将于5天内尽快审批，审批通过后可在个人中心「团体证书」查看并下载。';
    },
  },
  props: {
    count: '',
  },
  methods: {
    onFileChange($event) {
      const file = $event.target.files[0];
      if (this.loading) return false;
      this.loading = true;
      upload(file)
        .then((url) => {
          this.form.attachFileList.value.push({
            fileBizType: 'cover',
            type: 'image/png',
            uid: uuid(),
            name: file.name,
            url,
          });
        })
        .finally(() => {
          this.loading = false;
          if ($event && $event.target) {
            $event.target.value = '';
          }
        });
    },
    deleteFile(idx) {
      this.form.attachFileList.value.splice(idx, 1);
    },
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      if (this.submitting) {
        return;
      }
      if (!this.form.attachFileList.validate(this.form.attachFileList.value)) {
        return;
      }
      if (this.feeAmount === '-' || !this.feeAmount) {
        this.$message({
          type: 'error',
          content: '无法确定应缴金额，请联系管理员',
        });
        return;
      }
      this.submitting = true;
      payMemFee({
        payAmount: this.feeAmount,
        attachFileList: this.form.attachFileList.value,
      })
        .then(() => {
          this.submitted = true;
          this.$emit('confirm');
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            content: err,
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.contact-modal {
  width: 920px;
  background: #ffffff;
  padding: 28px 0 24px;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.06);

  &.is-success {
    width: 560px;
  }

  .modal-header {
    font-size: 20px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-bottom: 22px;
    position: relative;

    i {
      cursor: pointer;
      width: 20px;
      height: 20px;
      background: url(../../../assets/images/icon-close.png) no-repeat center center;
      background-size: 100% 100%;
      position: absolute;
      right: 24px;
      top: 2px;
    }
  }

  .modal-content {
    padding: 0 36px 12px;
    border-bottom: 1px solid #e8ecef;
    margin-bottom: 20px;
  }

  .success-content {
    padding: 24px 40px 36px;
    border-bottom: none;
    margin-bottom: 8px;
    text-align: center;
  }

  .success-icon {
    width: 64px;
    height: 64px;
    margin: 0 auto 20px;
    border-radius: 50%;
    background: rgba(6, 174, 99, 0.1);
    color: #06ae63;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
  }

  .success-title {
    font-size: 16px;
    line-height: 1.8;
    color: #333333;
    text-align: center;
  }

  .info-grid {
    display: flex;
    gap: 24px;
    margin-bottom: 16px;
  }

  .info-col {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .org-row {
    display: flex;
    gap: 24px;
    margin-bottom: 16px;
    align-items: stretch;

    .fee-standard {
      flex: 0 0 260px;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      gap: 8px;
    }

    .org-upload {
      flex: 1;
    }
  }

  .fee-standard {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 16px 18px;
    background: #f6fffb;
    border: 1px solid #b7eb8f;
    border-radius: 8px;
    flex-wrap: wrap;

    &-label {
      font-size: 15px;
      color: #595959;
      white-space: nowrap;
    }

    &-value {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      font-size: 15px;
      color: #262626;
      font-weight: 500;

      em {
        font-style: normal;
        font-size: 28px;
        color: #06ae63;
        font-weight: 600;
        margin: 0 2px;
      }
    }

  }

  .account-card {
    flex: 1;
    padding: 16px 18px;
    background: #fafafa;
    border: 1px solid #e8e8e8;
    border-radius: 8px;

    &-title {
      font-size: 15px;
      font-weight: 600;
      color: #262626;
      margin-bottom: 12px;
      padding-bottom: 10px;
      border-bottom: 1px dashed #e0e0e0;
    }
  }

  .account-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 1.6;

    &:last-child {
      margin-bottom: 0;
    }

    .label {
      flex-shrink: 0;
      width: 72px;
      color: #8c8c8c;
    }

    .value {
      flex: 1;
      color: #262626;
      word-break: break-all;
    }

    .value-account {
      font-family: Consolas, Monaco, monospace;
      font-size: 16px;
      font-weight: 600;
      color: #06ae63;
      letter-spacing: 0.5px;
    }
  }

  .pay-notice {
    padding: 14px 16px;
    background: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 8px;

    p {
      margin: 0;
      font-size: 14px;
      color: #874d00;
      line-height: 1.7;
    }

    .contact {
      margin-top: 10px;
      color: #595959;
    }
  }

  .upload-section {
    &-title {
      font-size: 15px;
      font-weight: 600;
      color: #262626;
      margin-bottom: 12px;

      em {
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        color: #8c8c8c;
        margin-left: 8px;
      }
    }
  }

  .upload-zone {
    padding: 18px 16px;
    background: #fafbfc;
    border: 1px dashed #d0d5dd;
    border-radius: 8px;
    transition: border-color 0.2s ease, background 0.2s ease;

    &:hover {
      border-color: #06ae63;
      background: #f6fffb;
    }

    &.has-files {
      border-style: solid;
      border-color: #b7eb8f;
      background: #fcfffe;
    }

    &.loading {
      opacity: 0.85;
    }
  }

  .upload-add {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 64px;
    cursor: pointer;
    border-radius: 6px;

    &-icon {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: #06ae63 url(../../../assets/images/icon-upload.png) no-repeat center center;
      background-size: 18px 18px;
      flex-shrink: 0;
    }

    &-text {
      font-size: 15px;
      font-weight: 500;
      color: #06ae63;
      line-height: 1.4;
    }

    > input {
      position: absolute;
      cursor: pointer;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }

  .error-tip {
    margin-top: 8px;
    font-size: 13px;
    color: #ff3b2f;
    line-height: 20px;
    text-align: center;
  }

  .upload-file-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px dashed #e8ecef;
  }

  .upload-file {
    width: 88px;
    padding: 8px;
    border-radius: 6px;
    background: #ffffff;
    border: 1px solid #e8ecef;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;

    > img {
      width: 56px;
      height: 56px;
      display: block;
      margin-bottom: 6px;
      object-fit: cover;
      border-radius: 4px;
    }

    span {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 12px;
      color: #595959;
      text-align: center;
    }

    &:hover {
      .upload-file-delete {
        display: block;
      }
    }

    &-delete {
      display: none;
      cursor: pointer;
      width: 16px;
      height: 16px;
      position: absolute;
      right: -6px;
      top: -6px;
      background: #ff3b2f url(../../../assets/images/icon-close.png) no-repeat center center;
      background-size: 6px 6px;
      border-radius: 50%;
    }
  }

  .footer-tip {
    font-size: 13px;
    color: #8c8c8c;
    line-height: 1.65;
    padding: 12px 14px;
    background: #f7f8fa;
    border-radius: 8px;
  }

  .modal-footer {
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      width: 128px;
      height: 42px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      outline: none;
      border: none;
      cursor: pointer;

      &.cancel {
        margin-right: 20px;
        color: #06ae63;
        background: rgba(6, 174, 99, 0.1);
      }

      &.confirm {
        background: #06ae63;
        color: #ffffff;

        &:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
      }
    }
  }
}
</style>
